module.exports = __webpack_public_path__ + "static/gallery-img-10-64e71a1085cfa446da0db5181f1c5a1b.jpg";